// components/zones/ZoneLayer.jsx
// import { Polygon } from "@vis.gl/react-google-maps";
import {
  AdvancedMarker,
  Circle,
  Polygon,
  useMap,
} from "@vis.gl/react-google-maps";
import { imageSet } from "../../../pages/icons/AssetIcon/IconList";
import { getUrl } from "../../../utils/staticMethods";
import defaultImg from "../../../assets/img/icon/Aircraft/Airliner_Black.png";
import useSrlHelper from "../../../hooks/useSrlHelper";
import React from "react";

/**
 * Renders all zones as polygon overlays.
 * Zones are never clustered.
 */
export function ZoneLayer({ zones }) {
  const map = useMap();
  const { itemDisplayName } = useSrlHelper();

  return zones.map((zone) => {
    const imageSrc = imageSet[getUrl(zone.icon)]
      ? require("../../../assets/img/icon/" + imageSet[getUrl(zone.icon)])
          .default
      : defaultImg;

    return (
      <React.Fragment key={zone.id}>
        {zone.latitude && zone.longitude && (
          <>
            <AdvancedMarker
              position={{
                lat: Number(zone.latitude),
                lng: Number(zone.longitude),
                altitude: 0,
              }}
              onClick={(e) => {
                // e.stopPropigation();
                map.setCenter({
                  lat: Number(zone.latitude),
                  lng: Number(zone.longitude),
                  altitude: 0,
                });
              }}
            >
              <div
                style={{ position: "relative", transform: "translateY(50%)" }}
              >
                <img src={imageSrc} width={24} alt="Marker" />
                <div
                  className="px-1 text-nowrap text-black bg-secondary bg-opacity-75 rounded"
                  style={{
                    position: "absolute",
                    bottom: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    marginTop: 4,
                    pointerEvents: "none",
                  }}
                >
                  {itemDisplayName(zone)}
                </div>
              </div>
            </AdvancedMarker>
            {zone.polygon && zone.polygon.length > 0 && (
              <Polygon
                key={zone.id}
                paths={zone.polygon.map((item) => {
                  let me = item.split(",");
                  let lng = Number(me[0]);
                  let lat = Number(me[1]);
                  return { lng, lat };
                })}
                // onClick={() => setSelectedId(zone.id)}
                options={{
                  strokeColor: "#000000",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: "#242424",
                  fillOpacity: 0.4,
                }}
              />
            )}
            {!zone.polygon && (
              <Circle
                center={{
                  lng: Number(zone.longitude),
                  lat: Number(zone.latitude),
                }}
                radius={Number(zone.radius)}
                options={{
                  strokeColor: "#090B29",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: "#090B29",
                  fillOpacity: 0.4,
                }}
              />
            )}
          </>
        )}
      </React.Fragment>
    );
  });
}
